import { render, staticRenderFns } from "./newVariantSelect.vue?vue&type=template&id=1ce12703&scoped=true&"
import script from "./newVariantSelect.vue?vue&type=script&lang=js&"
export * from "./newVariantSelect.vue?vue&type=script&lang=js&"
import style0 from "./newVariantSelect.vue?vue&type=style&index=0&id=1ce12703&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce12703",
  null
  
)

export default component.exports